import styled from "styled-components"
import {Col} from "react-bootstrap"
import Icon from "@irati/ui/src/Icon"

export const PerksGOIcon = styled(Icon)`
  height: 34px;
  width: 50px;
`

export const RightCol = styled(Col)`
  text-align: right;
`

export const Note = styled.div`
  margin-top: 10px;
`
